import React, { useEffect } from 'react';
import AOS from 'aos';
import { Container } from 'react-bootstrap';
import { FaInstagram, FaFacebookF, FaYoutube, FaBullhorn, FaUserGraduate } from 'react-icons/fa';
import './DigitalBrandingSection.css';
import 'aos/dist/aos.css';

function DigitalBrandingSection() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="digital-branding-section">
      <Container>
        <h2 className="branding-title" data-aos="fade-up">Powerful Branding</h2>

        <div className="branding-wrapper">
          <div className="branding-visuals" data-aos="fade-right">
            <div className="floating-icon insta"><FaInstagram /></div>
            <div className="floating-icon fb"><FaFacebookF /></div>
            <div className="floating-icon yt"><FaYoutube /></div>
            <div className="floating-icon student"><FaUserGraduate /></div>
            <div className="floating-icon ads"><FaBullhorn /></div>
          </div>

          <div className="branding-content" data-aos="fade-left">
            <p>
              We specialize in building a <strong>powerful, positive online identity</strong> for our partner schools.
              Our strategy includes:
            </p>
            <ul>
              <li><strong>Weekly reels & short videos</strong> from classrooms, events, and student activities posted on Instagram, Facebook, and YouTube.</li>
              <li><strong>Targeted local ads</strong> to drive high-quality admissions from the surrounding area.</li>
              <li><strong>Student-led content</strong>—turning students into the digital face of your school.</li>
              <li>Consistent weekly and monthly updates to keep school pages <strong>active, engaging, and trusted</strong>.</li>
            </ul>
            <p className="branding-outcome">
              This strategy will <strong>increase visibility</strong>, build <strong>local trust</strong>, enhance <strong>credibility</strong>, and inspire <strong>community pride</strong>.
            </p>
          </div>
        </div>
      </Container>
    </div>
  );
}

export default DigitalBrandingSection;
